import { ReturnHome } from 'app/components/error/ReturnHome';
import { useI18n } from 'core/hooks/useI18n';
import { ErrorBlock, ErrorLogo, Inner, MainHeading, SubHeading, Wrapper } from './Error.styles';
import { useEffect } from 'react';
import { LogManager } from 'core/logging/LogManager';

const logger = LogManager.getLogger('UnexpectedError', { error: { logToServer: true } });

interface IProps {
  componentStack?: string;
  error: Error;
}

export const UnexpectedError = ({ componentStack, error }: IProps) => {
  const { l10n } = useI18n('app/components', 'errors');
  const stringifiedError = error.toString();

  useLogError({ error: stringifiedError, componentStack });

  return (
    <Wrapper>
      <Inner>
        <ErrorLogo />
        <MainHeading>{l10n('unexpected.title')}</MainHeading>
        {stringifiedError && (
          <>
            <SubHeading>{l10n('unexpected.error', { suffix: ': ' })}</SubHeading>
            <ErrorBlock value={stringifiedError} />
          </>
        )}
        {componentStack && (
          <div>
            <SubHeading>{l10n('unexpected.stackTrace', { suffix: ': ' })}</SubHeading>
            <ErrorBlock value={componentStack} />
          </div>
        )}
        <ReturnHome />
      </Inner>
    </Wrapper>
  );
};

function useLogError({ error, componentStack }: { error: string; componentStack: string | undefined }) {
  const { l10n } = useI18n('app/components', 'errors');
  useEffect(() => {
    if (!error || !componentStack) return;
    logger.error(error, componentStack);
  }, [componentStack, error, l10n]);
}
